var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-body" },
    [
      _c("toast", { ref: "toast" }),
      _vm._v(" "),
      _c("ul", { staticClass: "nav nav-tabs" }, [
        _c("li", { staticClass: "nav-item" }, [
          _c(
            "a",
            {
              staticClass: "nav-link active",
              attrs: { href: "#tab1", "data-toggle": "tab" },
              on: {
                click: function($event) {
                  return _vm.setTab(1)
                }
              }
            },
            [_vm._v("最新")]
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "nav-item" }, [
          _c(
            "a",
            {
              staticClass: "nav-link",
              attrs: { href: "#tab2", "data-toggle": "tab" },
              on: {
                click: function($event) {
                  return _vm.setTab(2)
                }
              }
            },
            [_vm._v("履歴")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tab-content" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tab == 1,
                expression: "tab == 1"
              }
            ],
            staticClass: "tab-pane pt-3 active"
          },
          [
            _c("user-work-registration-view", {
              attrs: {
                result: _vm.result.userWorkRegistrationList[0],
                loginUser: _vm.loginUser
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tab == 2,
                expression: "tab == 2"
              }
            ],
            staticClass: "tab-pane pt-3 active"
          },
          [
            _vm.result.userWorkRegistrationList == null ||
            _vm.result.userWorkRegistrationList.length == 0
              ? _c("span", [_vm._v("なし")])
              : _c("table", [
                  _c("thead", { staticClass: "thead-light" }, [
                    _c("tr", [
                      _c("th", [_vm._v("No")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("作成日")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("更新日")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("添付")]),
                      _vm._v(" "),
                      _vm.hasAnyRole("ROLE_ADMIN", "ROLE_USER_ADMIN")
                        ? _c("th", [_vm._v("操作")])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.result.userWorkRegistrationList, function(
                      list,
                      index
                    ) {
                      return _c("tr", { key: list.id }, [
                        _c("td", [
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  return _vm.showHistory(list)
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.result.userWorkRegistrationList.length -
                                    index
                                ) + "回目"
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(list.createdAt))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(list.modifiedAt))]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(list.imageUrl ? "あり" : "なし"))
                        ]),
                        _vm._v(" "),
                        _vm.hasAnyRole("ROLE_ADMIN", "ROLE_USER_ADMIN")
                          ? _c("td", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-sm btn-outline-info",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.goWorkRegistrarionEdit(
                                        list.userId,
                                        list.id
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-edit" }),
                                  _vm._v("編集")
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "/api/user/download/excel/" + list.id
                                  }
                                },
                                [_vm._m(0, true)]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-sm btn-outline-danger",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.deleteUserWorkRegistration(
                                        list.id
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-trash" }),
                                  _vm._v("削除")
                                ]
                              )
                            ])
                          : _vm._e()
                      ])
                    }),
                    0
                  )
                ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tab == 3,
                expression: "tab == 3"
              }
            ],
            staticClass: "tab-pane pt-3 active"
          },
          [
            _c("user-work-registration-view", {
              attrs: { result: _vm.showResult, loginUser: _vm.loginUser }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-info btn-sm",
        staticStyle: { "border-radius": "50px" },
        attrs: { type: "button" }
      },
      [
        _c("i", {
          staticClass: "fas fa-cloud-download-alt fa-1x",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v("Excel\n                    ")
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e4f57a74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4f57a74","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/js/components/common/user/UserWorkRegistrationViewSummary.vue
// module id = 434
// module chunks = 0